import React from "react";
import { TrendingUp } from "lucide-react";
import { MARKET_STATS } from "../mock/data";

const MarketOpportunity = () => {
  return (
    <section className="relative py-24 lg:py-32 bg-[#0E0E13] overflow-hidden">
      <div className="absolute inset-0 stripe-overlay opacity-60" />

      <div className="relative max-w-[1480px] mx-auto px-6 lg:px-10">
        {/* Editorial header */}
        <div className="grid lg:grid-cols-12 gap-10 mb-20">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 mb-6">
              <TrendingUp className="w-4 h-4 text-[#14E0BF]" />
              <span className="font-mono text-[11px] text-[#14E0BF] uppercase tracking-[0.2em]">
                The Opportunity
              </span>
            </div>
            <h2 className="text-white">
              <span className="font-serif-display italic text-5xl lg:text-7xl leading-[0.95] block">
                Why Indian.
              </span>
              <span className="font-display text-5xl lg:text-7xl leading-[0.95] block mt-2">
                Why <span className="text-[#14E0BF]">Now.</span>
              </span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-20">
            <p className="text-white/70 text-lg lg:text-xl leading-relaxed max-w-[640px]">
              Indian food is the UK&rsquo;s most-ordered cuisine – and dark-kitchen delivery is the fastest-growing food segment in Britain. kitchnworx is the only franchise built at the intersection of both. We didn&rsquo;t copy a model. We built one.
            </p>
          </div>
        </div>

        {/* Stats grid – editorial bento */}
        <div className="grid lg:grid-cols-4 gap-4">
          {MARKET_STATS.map((s, i) => (
            <div
              key={i}
              className={`group relative overflow-hidden rounded-3xl border border-white/10 p-6 lg:p-8 transition-all duration-500 hover:border-[#14E0BF]/40 hover:-translate-y-1 ${
                i === 0 ? "bg-[#14E0BF] text-[#07070A] lg:row-span-2 lg:col-span-1" : "bg-[#14141B] text-white"
              }`}
            >
              <div className="relative">
                <div className="font-mono text-[11px] uppercase tracking-[0.18em] mb-4 opacity-60">
                  {String(i + 1).padStart(2, "0")} — {s.source}
                </div>
                <div
                  className={`font-serif-display ${
                    i === 0 ? "text-[110px] lg:text-[180px]" : "text-7xl lg:text-8xl"
                  } leading-[0.85] mb-4 italic`}
                >
                  {s.value}
                </div>
                <div
                  className={`text-base lg:text-lg leading-snug font-medium ${
                    i === 0 ? "text-[#07070A]/85" : "text-white/75"
                  }`}
                >
                  {s.label}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footnote */}
        <p className="mt-10 font-mono text-xs text-white/35 max-w-[640px]">
          Sources: IBISWorld UK Takeaway Industry Report 2024, Just Eat UK Trends Report Q4 2024, Deliveroo Restaurant Insights 2024, UK Food Standards Agency public register.
        </p>
      </div>
    </section>
  );
};

export default MarketOpportunity;
